/* 劉備傳・第 6 章：長坂坡（建安十三年，208）
 * 史實：《三國志·趙雲傳》「先主爲曹公所追於當陽長阪，棄妻子南走，雲身抱弱子，即後主也，保護甘夫人，即後主母也，皆得免難。」
 *       《張飛傳》：「飛將二十騎拒後。飛據水斷橋，瞋目橫矛曰：『身是張益德也，可來共決死！』敵皆無敢近者，故遂得免。」
 *       （七進七出、喝斷長坂橋是演義。）
 * 流程：1. 操作趙雲：在潰散的人群裡找到阿斗和甘夫人（四處只有一處是），抱著阿斗（不能放大招、走得慢一點）護著甘夫人到長坂橋。
 *       2. 改操作張飛：先斷橋，再據水瞋目。曹軍的「膽氣」被喝聲壓低；喝得太密就不靈了。膽氣回升超過一半，曹兵就會涉水過來。撐到敵皆無敢近者即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, swapPlayer, TROOPS, rout, troop } from '../kit.ts';
import { RIVER_Y, BRIDGE, SOUTH, REFUGE } from '../maps/changban.ts';

const LV = 13, HOLD = 45;
const HUBAO = troop('hubao', '虎豹騎', { armor: '#26335f', sleeve: '#1a2448', cloth: '#1a2448', plume: '#5070c0' }, SG.SOLDIERS.wei);
const RIDER = { spec: HUBAO, name: '虎豹騎', hp: 520, maxHp: 520, atk: 30, ms: 280 };

export default {
  id: 'liubei-6', map: 'changban', hero: 'zhaoyun',
  title: '第 6 章　長坂坡', year: '建安十三年（208）',
  brief: {
    quote: [{ text: '雲身抱弱子，即後主也，保護甘夫人，即後主母也，皆得免難。', src: '《三國志·蜀書·趙雲傳》' }],
    text: '曹操南下荊州，劉備帶著十幾萬百姓南撤，在當陽長坂被曹純的虎豹騎追上，丟下妻兒只帶數十騎逃走。（七進七出、喝斷長坂橋是演義。）',
    goals: ['趙雲：在亂軍中找到阿斗與甘夫人，護到長坂橋', '張飛：斷橋、據水瞋目', '撐到曹兵無敢近者'],
  },
  words: { ally: '騎兵', foe: '虎豹騎' },
  stars: [
    { text: '甘夫人與阿斗毫髮無傷', ok: (m) => !m.vars.ganHit },
    { text: '沒有一名曹兵過河', ok: (m) => !m.vars.crossed },
    { text: '瞋目不濫：喝聲一直保有七成以上的威勢', ok: (m) => m.vars.effMin >= 0.7 },
  ],
  steps: [
    { // 1. 趙雲找人
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = 4000; me.y = 1000;
        V.at = Math.floor(SG.rand() * 4);
        V.spots = REFUGE.map(([x, y], k) => { m.mark('r' + k, x, y, '潰散的人群', true); for (let i = 0; i < 4; i++) m.folk(x + (i - 1.5) * 50, y + (i % 2) * 40, { name: '百姓', still: true, near: 1, look: i % 4 }); return { x, y, seen: false }; });
        V.riders = Array.from({ length: 10 }, (_, i) => { const u = m.foe('huangjin', 2000 + (i % 5) * 900, 700 + Math.floor(i / 5) * 1600, RIDER); m.patrol(u, [[u.x, u.y], [u.x + 600, u.y + 700]]); return u; });
        m.card('先主爲曹公所追於當陽長阪，棄妻子南走。', '《趙雲傳》');
        m.line('趙雲', '主公的家眷還在亂軍中——我去找！');
        m.after(4, () => m.line('提示', '到每一群潰散的人那裡看看，阿斗和甘夫人只在其中一處。'));
        m.obj('find', '在亂軍中找到阿斗與甘夫人');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        V.spots.forEach((s, k) => {
          if (s.seen || !m.near(me, s.x, s.y, 220)) return;
          s.seen = true; m.unmark('r' + k);
          if (k === V.at) {
            V.found = true;
            V.gan = m.recruit(s.x + 60, s.y + 30, '甘夫人'); V.gan.hp = V.gan.maxHp = 800; V.gan.atk = 0; V.gan.ms = 260; V.gan.noFight = true; m.join(V.gan, me); // 甘夫人上了馬，只跟著趙雲走
            V.ganHp = V.gan.hp;
            w.addBuff(me, { id: '懷抱阿斗', t: 9999, ms: -0.1 });
            m.lock([3]);
            m.line('甘夫人', '子龍！阿斗在這裡！');
            m.after(2, () => m.line('趙雲', '夫人上馬，雲護您突圍！'));
          } else m.line('百姓', ['沒看到什麼夫人……', '將軍，救救我們！', '往南逃了吧？'][k % 3]);
        });
        return !!V.found;
      },
    },
    { // 2. 護到長坂橋
      enter(m, w) {
        m.done('find');
        m.mark('bridge', BRIDGE[0], BRIDGE[1] - 380, '長坂橋');
        m.obj('bridge', '抱著阿斗、護著甘夫人到長坂橋（不能放大招）');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        for (const u of m.alive(V.riders)) if (!(u.target && u.target.alive) && SG.gd(u.x, u.y, me.x, me.y) < 1200) { u.patrol = null; u.home = [me.x, me.y]; } // 看到趙雲的才追
        if (V.gan.hp < V.ganHp - 1) V.ganHit = true;
        V.ganHp = Math.min(V.ganHp, V.gan.hp);
        if (!V.gan.alive) { m.lose('甘夫人遇害'); return false; }
        const at = (u) => Math.abs(u.x - BRIDGE[0]) < 500 && u.y > BRIDGE[1] - 650; // 到了橋頭（走上橋也算）
        return at(me) && at(V.gan);
      },
    },
    { // 3. 張飛：斷橋
      enter(m, w) {
        const V = m.vars, yun = w.player;
        m.done('bridge'); m.unmark('bridge');
        m.card('雲身抱弱子，保護甘夫人，皆得免難。', '《趙雲傳》');
        for (const u of [yun, V.gan]) { const p = SG.MAP.nearestFree(SOUTH[0] + (u === yun ? 80 : -80), SOUTH[1]); u.x = p[0]; u.y = p[1]; u.input = {}; }
        rout(m, w, V.riders, [4000, 600]);
        const fei = ally(w, 'zhangfei', BRIDGE[0] + 260, BRIDGE[1] + 750, LV);
        swapPlayer(w, fei);
        m.unlock(3);
        V.yun = yun; V.fei = fei;
        V.twenty = Array.from({ length: 8 }, (_, i) => { const u = m.recruit(fei.x - 300 + (i % 4) * 200, fei.y + 120 + Math.floor(i / 4) * 80, '二十騎'); return u; });
        m.after(1.5, () => m.line('張飛', '子龍帶著小主人先走！這裡交給我！'));
        m.after(4, () => m.line('提示', '現在操作張飛：先到橋頭把橋拆了（站著讀條）。'));
        m.mark('cut', BRIDGE[0], BRIDGE[1] + 300, '斷橋');
        m.obj('cut', '斷橋');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        m.chanAt(me, 'cut', BRIDGE[0], BRIDGE[1] + 300, 180, 3, '斷橋', () => { V.cut = true; });
        return !!V.cut;
      },
    },
    { // 4. 據水瞋目
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('cut'); m.unmark('cut');
        m.gate('bridge', BRIDGE[0], BRIDGE[1], 140, 'repair', null, { a: Math.PI / 2, w: 190 });
        V.courage = 100; V.eff = 1; V.effMin = 1; V.lastRoar = -99; V.t3 = w.t;
        V.cao = [];
        for (let k = 0; k < 5; k++) m.after(k * 7, () => { for (let i = 0; i < 6; i++) { const u = m.foe('huangjin', 3200 + (i % 6) * 320, 2700 + (k % 2) * 120, Object.assign({}, RIDER, { spec: TROOPS.wei, name: '曹兵' })); u.home = [u.x, RIVER_Y - 330]; u.bank = true; V.cao.push(u); } });
        m.after(2, () => m.line('提示', '站在河邊不動就是「瞋目橫矛」，壓低曹軍的膽氣；喝得太密會越來越不靈。膽氣回升到一半以上，曹兵就會涉水過來。'));
        m.obj('hold', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, t = w.t - V.t3;
        // 喝聲的威勢：隔 8 秒以上才恢復
        V.eff = Math.min(1, V.eff + dt / 20);
        if (Math.abs(me.y - (RIVER_Y + 300)) < 200 && w.t - V.lastRoar > 3) m.chanAt(me, 'roar', me.x, me.y, 9999, 1, '瞋目橫矛', () => {
          V.courage = Math.max(0, V.courage - 35 * V.eff);
          if (w.t - V.lastRoar < 8) V.eff *= 0.55;
          V.effMin = Math.min(V.effMin, V.eff); V.lastRoar = w.t;
          m.line('張飛', ['身是張益德也，可來共決死！', '燕人張翼德在此！誰敢來決一死戰！', '來啊！'][Math.floor(SG.rand() * 3)]);
          w.fx({ k: 'boom', x: me.x, y: me.y - 40, r: 220, col: '#e0b04a' });
        }, { hurt: false });
        V.courage = Math.min(100, V.courage + dt * 2);
        // 膽氣過半：一部分曹兵涉水過來（從斷橋兩邊的淺處）
        for (const u of m.alive(V.cao)) {
          if (V.courage > 50 && !u.wade && SG.rand() < dt * 0.15) { u.wade = true; u.home = [u.x < BRIDGE[0] ? 2900 : 5100, RIVER_Y + 450]; } // 從淺水處涉水
          if (u.wade && u.y > RIVER_Y + 200) V.crossed = true;
          if (!u.wade) { u.target = null; u.think = 0.5; }
        }
        m.get('hold').text = `據水斷橋（曹軍膽氣 ${Math.round(V.courage)}%，喝聲威勢 ${Math.round(V.eff * 100)}%，還要撐 ${Math.max(0, Math.ceil(HOLD - t))} 秒）`;
        return t >= HOLD && V.courage < 60;
      },
    },
    { // 5. 敵皆無敢近者
      enter(m, w) {
        m.done('hold');
        m.card('飛據水斷橋，瞋目橫矛曰：「身是張益德也，可來共決死！」敵皆無敢近者，故遂得免。', '《張飛傳》');
        rout(m, w, m.vars.cao, [4000, 600]);
        m.after(7, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const V = m.vars;
    if (!w.player.alive) { m.lose(m.i >= 2 ? '張飛陣亡' : '趙雲陣亡'); return; }
    if (V.gan && !V.gan.alive && m.i < 2) m.lose('甘夫人遇害');
    if (V.twenty) for (const u of m.alive(V.twenty)) { u.home = u.home || [u.x, u.y]; }
  },
};

